import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import WorkshopHero from '@/components/WorkshopHero';
import LaggingIndicatorSection from '@/components/LaggingIndicatorSection';
import LaggingIndicatorDeep from '@/components/LaggingIndicatorDeep';
import SignalsSection from '@/components/SignalsSection';
import WorkshopBenefits from '@/components/WorkshopBenefits';
import Section3Benefits from '@/components/Section3Benefits';
import HostSection from '@/components/HostSection';
import PricingLight from '@/components/PricingLight';
import SuspendedSectionLight from '@/components/SuspendedSectionLight';
import PartnersSectionLight from '@/components/PartnersSectionLight';
import FooterLight from '@/components/FooterLight';
import PrivacyPolicy from '@/components/PrivacyPolicy';
import TermsOfService from '@/components/TermsOfService';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="app-container">
      {/* Main content */}
      <main>
        {/* Workshop Hero */}
        <WorkshopHero />
        
        {/* The Problem - Lagging Indicator Overview */}
        <LaggingIndicatorSection />
        
        {/* Deep Dive - Why Your Dashboard is Lying */}
        <LaggingIndicatorDeep />
        
        {/* 50+ Signals Section */}
        <SignalsSection />
        
        {/* What You'll Learn in Workshop */}
        <WorkshopBenefits />
        
        {/* What You Get with Section3.ai */}
        <Section3Benefits />
        
        {/* Your Host */}
        <HostSection />
        
        {/* Pricing (After Workshop) */}
        <PricingLight />
        
        {/* Suspended Sellers POA */}
        <SuspendedSectionLight />
        
        {/* Partners */}
        <PartnersSectionLight />
      </main>
      
      {/* Footer */}
      <FooterLight />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
